import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-183">
      <div className="max-w-4xl mx-auto text-center" data-id="element-184">
        {/* Logo */}
        <div className="text-[#F97316] text-3xl font-black tracking-widest mb-8" data-id="element-185">
          🥊 PROFEPACK™
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-186">
          El próximo lunes podés volver a improvisar la clase.
        </h2>
        <p className="text-[#F97316] text-2xl sm:text-3xl font-black mb-10" data-id="element-187">
          O podés entrar al gym con todo resuelto desde hoy.
        </p>

        {/* Cost Table */}
        <div className="bg-[#1a0f00] border border-[#F97316]/30 rounded-2xl overflow-hidden mb-12 max-w-2xl mx-auto text-left" data-id="element-188">
          <div className="p-4 bg-[#0d0700] border-b border-[#F97316]/30 text-center font-bold text-white" data-id="element-189">
            ¿Cuánto cuesta NO tenerlo?
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 bg-[#0d0700] border-b border-[#F97316]/30" data-id="element-190">
            <div className="p-4 font-bold text-gray-400 text-center" data-id="element-191">
              SIN MEGAPACK
            </div>
            <div className="p-4 font-bold text-[#F97316] text-center sm:border-l border-[#F97316]/30" data-id="element-192">
              CON MEGAPACK
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-193">
            <div className="p-4 text-gray-400 text-sm" data-id="element-194">
              100+ horas/año planificando desde cero
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-195">
              5 min/semana. El resto es entrenar
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-196">
            <div className="p-4 text-gray-400 text-sm" data-id="element-197">
              Clases improvisadas → mismo error por meses
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-198">
              140 clases listas → el progreso es visible
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-199">
            <div className="p-4 text-gray-400 text-sm" data-id="element-200">
              Alumnos que abandonan sin saber por qué
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-201">
              Sistema de retención → permanencia alta
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-202">
            <div className="p-4 text-gray-400 text-sm" data-id="element-203">
              Sin progresión clara → estancamiento
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-204">
              6 tomos progresivos → mejoran y se quedan
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-205">
            <div className="p-4 text-gray-400 text-sm" data-id="element-206">
              Sin Plan B cuando falta el equipo
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-207">
              Bono 3: 12 layouts listos para cualquier espacio
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-208">
            <div className="p-4 text-gray-400 text-sm" data-id="element-209">
              Niveles mezclados = caos de clase
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-210">
              Bono 1: Método 3 Carriles → todos mejoran juntos
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-211">
            <div className="p-4 text-gray-400 text-sm" data-id="element-212">
              Guanteo que escala y genera problemas
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-213">
              Bono 5: Protocolo 3C → guanteo seguro siempre
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 border-b border-gray-800" data-id="element-214">
            <div className="p-4 text-gray-400 text-sm" data-id="element-215">
              Sin sistema de medición de progreso
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-216">
              Fichas bimestrales → mostrás el avance con datos
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-217">
            <div className="p-4 text-gray-400 text-sm" data-id="element-218">
              Sin identidad profesional como entrenador
            </div>
            <div className="p-4 text-white font-bold text-sm bg-[#F97316]/5 sm:border-l border-gray-800" data-id="element-219">
              Sistema que justifica cobrar lo que realmente valés
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-220">
          <p className="text-white font-bold mb-4" data-id="element-221">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-222" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-223">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-224">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-2xl mx-auto" data-id="element-225">
          <div className="bg-[#0a0a0a] border border-[#F97316]/30 rounded-xl p-6 text-center flex flex-col" data-id="element-226">
            <div className="text-2xl mb-2" data-id="element-227">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-228">MEGAPACK BOXEO LISTO</h3>
            <p className="text-gray-400 text-xs mb-4" data-id="element-229">6 Tomos + 6 Bonos</p>
            <div className="mt-auto" data-id="element-230">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-231">
                Antes: $34.990 ARS
              </p>
              <p className="text-[#F97316] text-2xl font-black mb-4" data-id="element-232">
                Hoy: $19.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48567263133952:1" className="btn-green-pulse block bg-[#F97316] text-black font-black py-4 rounded-lg hover:bg-[#FB923C] transition-colors text-sm" data-id="element-233">
                → QUIERO MI MEGAPACK BOXEO LISTO
              </a>
            </div>
          </div>

          <div className="bg-[#0d0700] border-2 border-[#F97316] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(249,115,22,0.2)] flex flex-col" data-id="element-234">
            <div className="text-2xl mb-2" data-id="element-235">🏆</div>
            <h3 className="text-[#F97316] font-black mb-1" data-id="element-236">
              MEGAPACK + MÉTODO GYM LLENO ⭐
            </h3>
            <p className="text-gray-400 text-xs mb-1" data-id="element-237">La más elegida</p>
            <p className="text-gray-400 text-xs mb-4" data-id="element-238">
              6 Tomos + 6 Bonos + Método Gym Lleno™
              <br data-id="element-239" />
              (Sistema de precios, membresías, captación, retención y marketing
              local)
            </p>
            <div className="mt-auto" data-id="element-240">
              <p className="text-gray-400 line-through text-sm mb-1" data-id="element-241">
                Antes: $43.990 ARS
              </p>
              <p className="text-[#F97316] text-3xl font-black mb-4" data-id="element-242">
                Hoy: $27.990 ARS
              </p>
              <a href="https://www.profepack.com/cart/48567263166720:1" className="btn-green-pulse block bg-[#F97316] text-black font-black py-4 rounded-lg hover:bg-[#FB923C] transition-colors text-sm" data-id="element-243">
                → QUIERO EL MEGAPACK + MÉTODO GYM LLENO
              </a>
            </div>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-244">
          <span data-id="element-245">🔒 Pago 100% seguro</span>
          <span data-id="element-246">⚡ Acceso en 5 minutos</span>
          <span data-id="element-247">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-248">
            💳 Mercado Pago · Tarjeta de crédito · Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}